<template>
  <div class="sub-form-group">
    <BaseSwitcher
      :value="form.opened"
      @input="setView"
      label="View group as"
      hint="Set default view as open or closed"
    ></BaseSwitcher>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          opened: false
        }
      }
    },
    methods: {
      setView (val) {
        this.form.opened = val
      }
    }
  }
</script>

<style lang="scss">
  .sub-form-group {
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormGroup.vue